import React from 'react'
import { useGetCategoriesQuery } from '../../features/categories/categoriesApiSlice'
import Category from "./Category";

const Categories = () => {
    const { data: categories } = useGetCategoriesQuery()

    return (
        <div className="app_container">
            <div id="categories" className="categories">
                {categories?.map((category) => (
                    <Category key={category.category_id} category={category}/>
                ))}
            </div>
        </div>
    )
}

export default Categories
